<tt-page *ngIf="!!edit">
    <tt-card class="col-xs-12 col-md-4 sp-0">
        <tt-input ttLabel="oeestate_name" [ttModel]="edit.oeestate_name" ttReadonly></tt-input>
        <tt-input ttLabel="oeestateremark_name" [(ttModel)]="edit.oeestateremark_name"></tt-input>
        <tt-checkbox ttLabel="show_remarktext" [(ttModel)]="edit.show_remarktext"></tt-checkbox>
        <tt-button-save ttText="save" (ttClick)="saveChanges()" [ttLoading]="saving"></tt-button-save>
    </tt-card>
</tt-page>

<!--<tt-page class="col-xs-12 sp-0">
    <tt-card class="col-xs-12 col-md-4 sp-0">
        <tt-input class="col-xs-12 sp-0" tt-label="oeestate_name" tt-model="vm.model.edit.oeestate_name" tt-change="vm.model.edit.oeestate_name = $value" tt-readonly="true"></tt-input>
        <tt-input class="col-xs-12 sp-0" tt-label="oeestateremark_name" tt-model="vm.model.edit.oeestateremark_name" tt-change="vm.model.edit.oeestateremark_name = $value" tt-placeholder=""></tt-input>
        <tt-checkbox class="col-xs-12 sp-0" tt-label="show_remarktext" tt-model="vm.model.edit.show_remarktext" tt-change="vm.model.edit.show_remarktext = $value"></tt-checkbox>
        <tt-button-save class="col-xs-12 sp-0" tt-text="save" tt-locked="vm.model.lockedSave" tt-click="vm.saveChanges()" tt-text-align="center"></tt-button-save>
    </tt-card>
</tt-page>-->
